export default __webpack_public_path__ + "static/media/KamilaCamillo_01.95d65fc6.jpg";